import { render, staticRenderFns } from "./service-checkout.vue?vue&type=template&id=314597e5&scoped=true"
import script from "./service-checkout.vue?vue&type=script&lang=js"
export * from "./service-checkout.vue?vue&type=script&lang=js"
import style0 from "./service-checkout.vue?vue&type=style&index=0&id=314597e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314597e5",
  null
  
)

export default component.exports